import { Link } from 'gatsby';
import ProductsArticles from 'components/Outdoor_Cameras/IntroOutdoorCams';
import NavButtons from 'components/Products/NavButtons';
import CompareOutdoor from 'components/Products/Compare/CompareOutdoorFlyout';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  Link,
  ProductsArticles,
  NavButtons,
  CompareOutdoor,
  BreadCrumbs,
  SEOHelmet,
  React
};